/**
* Parse hash bang parameters from a URL as key value object.
* 
* For repeated parameters the last parameter is effective.
* 
* If = syntax is not used the value is set to null.
* 
* #!x+y:3 -> { x:null, y:3 }
* 
* @param options 
* 
* @return Object of key -> value mappings.
*/
export function parseHashBangArgs(/*Object*/options) {
    options = options || {};

    var href = options.href || window.location.href;
    if (!!!(href.indexOf("#") + 1)) return false;


    var vars = {},
        paramDelimiter = options.paramDelimiter || ";",
        valueDelimiter = options.valueDelimiter || "=",
        hashes = href.slice(href.indexOf("#") + 1).split(paramDelimiter),
        i = hashes.length;

    while (i--) {
        var hash = hashes[i].split(valueDelimiter);
        vars[hash[0]] = (hash.length > 1)
            ? hash[1]
            : null;
    }

    return vars;
};

export function clearHash() {
    if (window.history.pushState) {
        window.history.pushState('', '/', window.location.pathname)
    } else {
        window.location.hash = '';
    }
}

const ParamsUtils = {
    parseHashBangArgs,
    clearHash
}
export default ParamsUtils
